import Link from 'next/link'
import { StyledHero, StyledLinkItem, StyledLinks } from './style'
import Typography from '@mui/material/Typography'
import { useRouter } from 'next/router'

type Props = {
  title: string
  meta: string
}

const Breadcrumb: React.FC<Props> = ({ title = '', meta = '' }) => {
  const router = useRouter()

  const { id: resumeID } = router.query

  return (
    <StyledHero component={'section'}>
      <div>
        <Typography variant="h5_semibold" component={'h1'}>
          {title}
        </Typography>
        <StyledLinks component={'ul'}>
          <StyledLinkItem component={'li'}>
            <Link href={resumeID ? `/r/${resumeID}/dashboard` : '/auth'}>
              <Typography variant="body_m_regular" color={'darkGray.main'}>
                Home
              </Typography>
            </Link>
          </StyledLinkItem>
          <StyledLinkItem>
            <Typography variant="body_m_regular" color={'darkGray.main'}>
              {meta}
            </Typography>
          </StyledLinkItem>
        </StyledLinks>
      </div>
    </StyledHero>
  )
}

export default Breadcrumb
